import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LeaveDocumentApproval from "../LeaveManagement/ApplyLeave/LeaveDocumentApproval";
import LeaveCancellationDocumentApproval from "../LeaveManagement/LeaveCancellation/LeaveCancellationDocumentApproval";
import TimeManagementDocumentApproval from "../TimeManagement/TimeManagementDocumentApproval";
import ClaimDocumentApproval from "../Reimbursement/ClaimDocumentApproval";
import ResignationDocumentApproval from "../resignation/ResignationDocumentApproval";
import AttendanceDocumentApproval from "../AttendanceManagement/AttendanceDocumentApproval";
import PayslipDocumentApproval from "../PayrollManagement/PayslipDocumentApproval";
import SettlementDocumentApproval from "../FullandFinalSettlement/SettlementDocumentApproval";

const DocumentViewer = ({
  type,
  isOpen,
  onClose,
  requests,
  approvers,
  approvalStatus,
  updateHistory,
}) => {
  const [value, setValue] = useState("1");
  const [internalRequests, setInternalRequests] = useState(requests);
  const [closeRequest, setCloseRequest] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setInternalRequests(requests);
  }, [requests]);

  // Handle close request
  useEffect(() => {
    if (closeRequest) {
      onClose();
      setCloseRequest(false);
    }
  }, [closeRequest, onClose]);

  const commonProps = {
    openViewRequest: isOpen,
    setOpenViewRequest: onClose,
    requests: internalRequests,
    setRequests: setInternalRequests,
    setCloseRequest: setCloseRequest,
  };

  const tabProps = {
    ...commonProps,
    value,
    handleChange,
    approvalStatus,
    updateHistory,
  };

  const renderDocumentViewer = () => {
    switch (type) {
      case "Leave":
        return <LeaveDocumentApproval {...tabProps} />;

      case "Leave Cancellation":
        return <LeaveCancellationDocumentApproval {...tabProps} />;

      case "timesheet":
        return <TimeManagementDocumentApproval {...tabProps} />;
      
      case "TimesheetLog":
        return <TimeManagementDocumentApproval {...tabProps} />;

      case "Reimbursement":
        return <ClaimDocumentApproval {...tabProps} />;

      case "Resignation":
        return <ResignationDocumentApproval {...tabProps} />;

      case "Attandance Management":
        return <AttendanceDocumentApproval {...commonProps} />;

      case "payroll management":
        return <PayslipDocumentApproval {...commonProps} />;

      case "Full and Final Settlement":
        return <SettlementDocumentApproval {...tabProps} />;

      default:
        return (
          <Dialog open={isOpen} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>
              Document Viewer
              <IconButton onClick={onClose} sx={{ float: "right" }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Typography>No viewer available for {type}</Typography>
            </DialogContent>
          </Dialog>
        );
    }
  };

  return renderDocumentViewer();
};

export default DocumentViewer;
